import type DataQueryDefinitionFactory from './DataQueryDefinition';
import type { DataQueryColumnFactory } from './DataQueryColumnFactory';

type InternalDataQuery = InstanceType<ReturnType<typeof DataQueryDefinitionFactory>>;
type InternalDataQueryColumn = InstanceType<ReturnType<typeof DataQueryColumnFactory>>;

export const enum ColumnAlignmentsEnum {
	Left = 0,
	Center = 1,
	Right = 2,
}

export const enum ColumnDisplayImageEnum {
	None = 0,
	Image = 1,
	ImageWithText = 2,
}

export type DataQueryColumn = InternalDataQueryColumn & {
	AttributeValueType: string; //enum MxObjectPropertyType
	Name: string;
	Title: string;
	ReferenceTo?: string;
	ReferenceFilter?: string;
	IsEnum: boolean;
	IsPickup: boolean;
	Format?: string;
	GroupingIsAvailable: boolean;
	Alignment: ColumnAlignmentsEnum;
	Expression: string;
	EntityClassName: string;
	DisplayImage: ColumnDisplayImageEnum;
	ImageScript: string;
};

export type DataQuery = InternalDataQuery & {
	ServiceInfo?: {
		Name: string;
		Id: string;
	};
};
